import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { InputTextArea } from 'components';
import Literal from 'components/literal';
import { t } from 'utils/getLiteral';
class CrudTextArea extends PureComponent {
    constructor(props) {
        super(props);
        this.inputRef = React.createRef();
    }

    handleClear = () => {
        const { input } = this.props;
        input.onChange('');
    };

    onBlur = () => {
        const { input, onBlur = () => null } = this.props;
        onBlur(input);
    };

    focus() {
        if (this.inputRef && this.inputRef.current) {
            this.inputRef.current.focus();
        }
    }

    render() {
        const {
            input,
            placeholder = 'cfm_placeholder_type_value',
            readOnly,
            onFocus,
            isClearable = true,
            meta: { touched, error },
            minRows = 1,
            maxRows = 20,
            dataTest,
        } = this.props;
        const { name, value, onBlur, onFocus: onFocusInput, ...rest } = input;

        const cleanVal = value !== undefined && value !== null ? value.toString() : '';

        const hasError = touched && error && error.length > 0;

        return (
            <Fragment>
                <InputTextArea
                    ref={this.inputRef}
                    placeholder={t(placeholder)}
                    readOnly={readOnly}
                    onClearClick={this.handleClear}
                    value={cleanVal}
                    onBlur={this.onBlur}
                    hasError={hasError}
                    name={name}
                    id={name}
                    onFocus={onFocus}
                    isClearable={isClearable}
                    minRows={minRows}
                    maxRows={maxRows}
                    dataTest={dataTest}
                    {...rest}
                />
                {hasError && (
                    <p className="crud-error-message">
                        <Literal literal="cfm_label_required_field" />
                    </p>
                )}
            </Fragment>
        );
    }
}

CrudTextArea.propTypes = {
    input: PropTypes.shape({}).isRequired,
    meta: PropTypes.shape({}).isRequired,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    placeholder: PropTypes.string,
    readOnly: PropTypes.bool,
    isClearable: PropTypes.bool,
    minRows: PropTypes.number,
    maxRows: PropTypes.number,
    dataTest: PropTypes.string.isRequired,
};

export default CrudTextArea;
